import React from 'react';
import {Section} from '../atoms/Section'
import styled from 'styled-components'
import {FooterLink} from '../atoms/Link'
import {CopyText} from '../atoms/Text'

export const Footer = (props) => {
    const links = props.links ? props.links : [];
    return(
      <Section direction="column" background="dimgray">
      <Div>
        <FlexWrap>
        {links.map((item,index) => (
          <FooterLink key={index} href={item.href}> 
            {item.text}
          </FooterLink>
        ))}
        </FlexWrap>
        <CopyText>{props.copyRights}</CopyText>
      </Div>
      </Section>
    );
};

const Div = styled.div`
  margin:20px;
  padding-bottom:${props => props.theme.gutter.sp};
  @media screen and (min-width: ${props => props.theme.breakpoints.values.sm}px){
    margin:80px;
    padding-bottom:0;
  }
`;

const FlexWrap = styled.div`
  display: flex;
  flex-wrap:wrap;
  justify-content: center;
  align-items: center;
  width:100%;
`